import React, { useEffect } from "react";
import { Link } from "react-router-dom";

function ShopPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Shop Section */}
      <section className="bg-yellow-50 pt-10 pb-[50px]">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl md:text-6xl font-black text-center mb-6 text-yellow-600" style={{ fontFamily: "'Chalkboard SE', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
            The Sandbox Shop 🧸
          </h2>
          <p className="text-xl md:text-2xl text-center text-gray-700 mb-16 font-semibold">Discover our favorite storybooks, clothing, and activity books for your little explorers!

          </p>

          {/* Puzzles Category - Top Section */}
          <div className="mb-16">
            <div className="flex items-center justify-between mb-8">
              <h3 className="text-3xl md:text-4xl font-black text-yellow-600" style={{ fontFamily: "'Chalkboard SE', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>Color, Play & Learn 🧩
              </h3>
              <Link to="/shop/color-play-learn" className="text-yellow-600 hover:text-yellow-700 font-bold text-lg underline">
                View All →
              </Link>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {[1, 2, 3].map((item) =>
              <div key={item} className="bg-white rounded-2xl shadow-lg overflow-hidden transform transition-all duration-300 hover:scale-105 border-4 border-yellow-200">
                  <div className="h-48 bg-gradient-to-br from-yellow-200 to-yellow-400 flex items-center justify-center text-6xl">
                    🧩
                  </div>
                  <div className="p-4">
                    <h4 className="font-bold text-lg text-gray-800 mb-2">Puzzle {item}</h4>
                    <p className="text-sm text-gray-600 mb-3">24 pieces</p>
                    <button className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-2 px-4 rounded-full shadow-md transform transition-all duration-300 hover:scale-105">
                      View on Amazon
                    </button>
                  </div>
                </div>
              )}
              {/* View All Card */}
              <div className="flex items-center justify-center">
                <div className="rounded-[15px] border-2 border-dashed border-yellow-300 flex flex-col items-center justify-center h-[140px] w-[80px] transform transition-all duration-300 hover:scale-110 cursor-pointer mx-4" style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
                  <Link to="/shop/color-play-learn" className="flex flex-col items-center justify-center gap-2 p-3 w-full h-full">
                    <div className="text-2xl text-yellow-500">→</div>
                    <p className="text-xs font-bold text-yellow-600 text-center">View All</p>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Storybooks Category - Middle Section */}
          <div className="mb-16">
            <div className="flex items-center justify-between mb-8">
              <h3 className="text-3xl md:text-4xl font-black text-sky-600" style={{ fontFamily: "'Chalkboard SE', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>Adventure Storybooks 📚
              </h3>
            </div>
            <div className="bg-gradient-to-br from-amber-50 via-orange-50 to-pink-50 rounded-3xl p-12 text-center border-4 border-orange-200 shadow-2xl min-h-[280px] flex flex-col items-center justify-center">
              <div className="text-6xl mb-4">📖</div>
              <p className="text-lg md:text-xl text-gray-800 leading-relaxed mb-4 max-w-2xl mx-auto">
                <strong>Ready for an Adventure?</strong> Willow's Wobbly Wheels is rolling into the Sandbox soon! Don't miss the first printing—Join the Sandbox Family below to get an alert the moment we launch.
              </p>
              <div className="text-4xl animate-bounce mt-4">↓</div>
            </div>
          </div>

          {/* Apparel Category - Bottom Section */}
          <div>
            <div className="flex items-center justify-between mb-8">
              <h3 className="text-3xl md:text-4xl font-black text-lime-600" style={{ fontFamily: "'Chalkboard SE', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
                Kid's Apparel 👕
              </h3>
            </div>
            <div className="bg-gradient-to-br from-rose-50 via-yellow-50 to-lime-50 rounded-3xl p-12 text-center border-4 border-rose-200 shadow-2xl min-h-[280px] flex flex-col items-center justify-center">
              <div className="text-6xl mb-4">👕</div>
              <p className="text-lg md:text-xl text-gray-800 leading-relaxed mb-4 max-w-2xl mx-auto">
                <strong>Wear the Fun!</strong> Our play-ready custom apparel collection is almost here. Join the Sandbox Family below for exclusive early access and launch-day surprises.
              </p>
              <div className="text-4xl animate-bounce mt-4">↓</div>
            </div>
          </div>
        </div>
      </section>
    </div>);

}

export default ShopPage;